import { render } from "./RfpCategorySelect.vue?vue&type=template&id=b0b170ce&ts=true"
import script from "./RfpCategorySelect.vue?vue&type=script&lang=ts"
export * from "./RfpCategorySelect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__